<template>

  <div style="padding:10px;background-color: #F5F5F5;min-height: 100vh">
    <div style="width: 700px;margin: auto;background-color: #fff;padding: 20px;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)">
      <ApplyDetailInfo :id="id"></ApplyDetailInfo>
    </div>

  </div>

</template>

<script>
  import ApplyDetailInfo from '../apply/ApplyDetailInfo'
    export default {
      components:{ApplyDetailInfo},
      name: "OpenApply.vue",
      data(){
        return{
          id:0
        }
      },
      created(){
        this.id = this.$router.currentRoute.query.id;
      },

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oem/OpenApply.vue